export const css = {
    root: '_3z9kPVLJ',
    clear: '_2VzK9Afu',
    player: '_2t8YEr5h',
    playlist: '_36pPm9ER',
    playlistTitle: '_3WxtPc2f',
    playlistItem: '_2QQcRfMa',
    ' _key': 'certwise-theme/certwise/audio/audio'
};
export default css;
